import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizensServices} from './citizens-services.model';
import * as CitizensServicesActions from './citizens-services.actions';

export const citizensServicesesFeatureKey = 'citizensServiceses';

export interface State extends EntityState<CitizensServices> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensServices> = createEntityAdapter<CitizensServices>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensServicesActions.addCitizensServices,
    (state, action) => adapter.addOne(action.citizensServices, state)
  ),
  on(CitizensServicesActions.upsertCitizensServices,
    (state, action) => adapter.upsertOne(action.citizensServices, state)
  ),
  on(CitizensServicesActions.addCitizensServicess,
    (state, action) => adapter.addMany(action.citizensServicess, state)
  ),
  on(CitizensServicesActions.upsertCitizensServicess,
    (state, action) => adapter.upsertMany(action.citizensServicess, state)
  ),
  on(CitizensServicesActions.updateCitizensServices,
    (state, action) => adapter.updateOne(action.citizensServices, state)
  ),
  on(CitizensServicesActions.updateCitizensServicess,
    (state, action) => adapter.updateMany(action.citizensServicess, state)
  ),
  on(CitizensServicesActions.deleteCitizensServices,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensServicesActions.deleteCitizensServicess,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensServicesActions.loadCitizensServicess,
    (state, action) => adapter.setAll(action.citizensServicess, state)
  ),
  on(CitizensServicesActions.clearCitizensServicess,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
